module.exports = __webpack_public_path__ + "insights-logotype-4f66f0e5e4d4dbff072fedc4e2658656.svg";